import { render, staticRenderFns } from "./CandidateOnBoardDocsModal.vue?vue&type=template&id=d145d812&scoped=true"
import script from "./CandidateOnBoardDocsModal.vue?vue&type=script&lang=js"
export * from "./CandidateOnBoardDocsModal.vue?vue&type=script&lang=js"
import style0 from "./CandidateOnBoardDocsModal.vue?vue&type=style&index=0&id=d145d812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d145d812",
  null
  
)

export default component.exports